import React from 'react';
import View from "react-native-web/dist/exports/View";
import StackWrapBox from './StackWrapBox';
import { a11yProps, getA11yPropsFromHtmlTag, selectSystemProps, useSpacingScale, useResponsiveProp, viewProps } from '../utils';
import { useThemeTokens } from '../ThemeProvider';
import { useViewport } from '../ViewportProvider';
import getStackedContent from './getStackedContent';
import { staticStyles, selectFlexStyles } from './common';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps] = selectSystemProps([a11yProps, viewProps]);

/**
 * The primary implementation of StackWrap.
 *
 * This is not intended to be used directly. It will automatically be used instead of StackWrap if:
 *
 * - On web, and,
 * - On a browser that supports CSS `gap` (most browser versions from 2020 onwards), and,
 * - The `space` between items is the same as the `gap` between wrapped rows (this is the
 *   default if `gap` prop is undefined)
 */
const StackWrapGap = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    space = 1,
    tokens,
    variant,
    direction: directionProp = 'row',
    children,
    tag,
    accessibilityRole,
    ...rest
  } = _ref;
  const viewport = useViewport();
  const direction = useResponsiveProp(directionProp, 'row');
  const themeTokens = useThemeTokens('StackView', tokens, variant, {
    viewport
  });
  const flexStyles = selectFlexStyles(themeTokens);
  const selectedProps = selectProps({
    accessibilityRole,
    ...getA11yPropsFromHtmlTag(tag, accessibilityRole),
    ...rest
  });
  const size = useSpacingScale(space);
  const gapStyle = {
    gap: size
  };
  const content = getStackedContent(children, {
    direction,
    space: 0
  });
  return /*#__PURE__*/_jsx(View, {
    ref: ref,
    ...selectedProps,
    style: [flexStyles, staticStyles.wrap, staticStyles[direction], gapStyle],
    children: content
  });
});
StackWrapGap.displayName = 'StackWrapGap';
StackWrapGap.propTypes = StackWrapBox.propTypes;
export default StackWrapGap;